import { z } from 'zod';
export const runScheduledTaskSchema = z.object({
    task_id: z.string(),
});
export const deleteScheduledTaskDataSchema = z.object({
    table_name: z.string(),
    value_date: z.iso.date(),
});
